import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useCart } from "../context/CartContext";
import { api } from "../lib/api";

export default function Checkout() {
  const { items, total, clear } = useCart();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", address: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (items.length === 0) {
      // empty cart redirect handled in render
    }
  }, [items.length]);

  const submit = async (e) => {
    e.preventDefault();
    if (items.length === 0) return;
    setLoading(true);
    try {
      const payload = {
        items: items.map((it) => ({ product_id: it.product_id, quantity: it.quantity })),
        origin_url: window.location.origin,
        customer_email: form.email,
        customer_name: form.name,
        shipping_address: form.address,
      };
      const { data } = await api.post("/checkout/session", payload);
      if (data?.url) {
        window.location.href = data.url;
      } else {
        throw new Error("Sessione non valida");
      }
    } catch (err) {
      console.error(err);
      toast.error("Errore checkout", { description: err?.response?.data?.detail || "Riprova." });
      setLoading(false);
    }
  };

  if (items.length === 0) {
    return (
      <div data-testid="checkout-empty" className="py-32 text-center">
        <div className="font-serif text-3xl mb-3">Il tuo carrello è vuoto</div>
        <p className="text-sm text-alimi-inkSoft mb-8">Aggiungi qualche creazione prima di procedere.</p>
        <Link to="/shop" className="btn-outline">Vai allo shop</Link>
      </div>
    );
  }

  return (
    <div data-testid="checkout-page" className="max-w-[1200px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 lg:grid-cols-5 gap-12">
      <form onSubmit={submit} className="lg:col-span-3 space-y-6">
        <div>
          <span className="overline">Checkout</span>
          <h1 className="font-serif text-4xl sm:text-5xl mt-4 tracking-tight">Finalizza l'ordine</h1>
        </div>

        <div>
          <label className="overline block mb-2">Nome e cognome</label>
          <input data-testid="checkout-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full px-4 py-3 bg-alimi-surface border border-alimi-border focus:border-alimi-ink outline-none text-sm" />
        </div>
        <div>
          <label className="overline block mb-2">Email</label>
          <input data-testid="checkout-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full px-4 py-3 bg-alimi-surface border border-alimi-border focus:border-alimi-ink outline-none text-sm" />
        </div>
        <div>
          <label className="overline block mb-2">Indirizzo di spedizione</label>
          <textarea data-testid="checkout-address" required rows={3} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className="w-full px-4 py-3 bg-alimi-surface border border-alimi-border focus:border-alimi-ink outline-none text-sm resize-none" placeholder="Via, città, CAP, paese" />
        </div>

        <button data-testid="checkout-pay-btn" type="submit" disabled={loading} className="btn-primary w-full">
          {loading ? "Reindirizzamento…" : `Paga € ${total.toFixed(2)}`}
        </button>
        <p className="text-xs text-alimi-inkSoft">Pagamenti sicuri gestiti da Stripe.</p>
      </form>

      <aside className="lg:col-span-2 bg-alimi-surface2 p-8 self-start">
        <div className="overline mb-5">Riepilogo</div>
        <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2">
          {items.map((it) => (
            <div key={it.product_id} className="flex gap-4">
              {it.image && <img src={it.image} alt="" className="w-16 h-20 object-cover" />}
              <div className="flex-1 text-sm">
                <div className="font-serif">{it.name}</div>
                <div className="text-xs text-alimi-inkSoft mt-1">Q.tà {it.quantity}</div>
              </div>
              <div className="text-sm">€ {(it.price * it.quantity).toFixed(2)}</div>
            </div>
          ))}
        </div>
        <div className="mt-6 pt-6 border-t border-alimi-border flex justify-between">
          <span className="text-sm text-alimi-inkSoft">Totale</span>
          <span data-testid="checkout-total" className="font-serif text-2xl">€ {total.toFixed(2)}</span>
        </div>
      </aside>
    </div>
  );
}
